
import PModal from "@/components/look/PModal.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "warning-modal",
  components: {
    PModal,
  },
})
export default class WarningModal extends Vue {}
